export type comment = {
  author: string;
  date: string;
  body: string;
  children?: comment[];
  showChildren?: boolean;
};

export type thread = comment[];
